import React from 'react';
import { useTranslation } from 'react-i18next';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const { t } = useTranslation();
  if (totalPages <= 1) return null;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '1.5rem',
        padding: '1rem',
        background: '#1a1a1a',
        color: '#ffffff',
        borderRadius: '8px',
        marginTop: '1rem',
        fontSize: '14px',
      }}
    >
      {currentPage > 1 ? (
        <button
          onClick={() => onPageChange(currentPage - 1)}
          style={{
            background: 'transparent',
            border: '1px solid #f97316',
            color: '#f97316',
            padding: '6px 14px',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '14px',
          }}
        >
          {t('admin.pagination.previous')}
        </button>
      ) : (
        <span style={{ color: '#444', padding: '6px 14px' }}>{t('admin.pagination.previous')}</span>
      )}

      <span style={{ color: '#a1a1aa' }}>
        {t('admin.pagination.page', { current: currentPage, total: totalPages })}
      </span>

      {currentPage < totalPages ? (
        <button
          onClick={() => onPageChange(currentPage + 1)}
          style={{
            background: 'transparent',
            border: '1px solid #f97316',
            color: '#f97316',
            padding: '6px 14px',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '14px',
          }}
        >
          {t('admin.pagination.next')}
        </button>
      ) : (
        <span style={{ color: '#444', padding: '6px 14px' }}>{t('admin.pagination.next')}</span>
      )}
    </div>
  );
};

export default Pagination;
